import i18n from 'i18next';

import { getFilterDropdown, getOnFilter, None, sortBy } from 'components/data/helpers';
import {
  CORNIS_BULK_UPLOAD_OPTIONS,
  CSV_BULK_UPLOAD_OPTIONS,
  JSON_BULK_UPLOAD_OPTIONS,
} from 'utils/constants';

export const MIN_DISTANCE = -3;
export const MAX_DISTANCE = 200;

// for uploadedImages
export function filePath(paths: any[]) {
  const fileFilterConfig = { key: 'path', type: 'string', values: paths, exactMatch: false };

  return {
    key: 'path',
    title: i18n.t('table.filePath', 'File Path'),
    sorter: sortBy('path'),
    filters: paths.map((p) => ({
      text: p,
      value: p,
    })),
    filterProperty: 'path',
    filterDropdown: getFilterDropdown(fileFilterConfig),
    onFilter: getOnFilter(fileFilterConfig as any),
    render(record: any) {
      const { path, name } = record;
      return (
        <span data-testid="inspection-upload-file-path">
          {path ? path.replace(name, '') : <None />}
        </span>
      );
    },
  };
}

export const completed = {
  key: 'completed',
  title: i18n.t('table.complete', 'Complete'),
  filterProperty: 'completed',
  className: 'hidden-column',
};

export const getBulkUploadEventTypes = (bulkUploadType: string) => {
  switch (bulkUploadType) {
    case CSV_BULK_UPLOAD_OPTIONS.CSV_BULK:
      return {
        inspectionType: CSV_BULK_UPLOAD_OPTIONS.CSV_BULK,
        validate: CSV_BULK_UPLOAD_OPTIONS.CSV_BULK_VALIDATE,
        validated: CSV_BULK_UPLOAD_OPTIONS.CSV_BULK_VALIDATED,
        generate: CSV_BULK_UPLOAD_OPTIONS.CSV_BULK_GENERATE,
        acceptedMetadataFileTypes: 'text/csv,text/x-csv,application/vnd.ms-excel',
        imageFileTypes: 'image/jpeg,.cr2',
      };
    case JSON_BULK_UPLOAD_OPTIONS.JSON_BULK:
      return {
        inspectionType: JSON_BULK_UPLOAD_OPTIONS.JSON_BULK,
        validate: JSON_BULK_UPLOAD_OPTIONS.JSON_BULK_VALIDATE,
        validated: JSON_BULK_UPLOAD_OPTIONS.JSON_BULK_VALIDATED,
        generate: JSON_BULK_UPLOAD_OPTIONS.JSON_BULK_GENERATE,
        acceptedMetadataFileTypes: 'text/plain,application/json',
        imageFileTypes: 'image/jpeg,.cr2',
      };
    case CORNIS_BULK_UPLOAD_OPTIONS.CORNIS_BULK:
      return {
        inspectionType: CORNIS_BULK_UPLOAD_OPTIONS.CORNIS_BULK,
        validate: CORNIS_BULK_UPLOAD_OPTIONS.CORNIS_BULK_VALIDATE,
        validated: CORNIS_BULK_UPLOAD_OPTIONS.CORNIS_BULK_VALIDATED,
        generate: CORNIS_BULK_UPLOAD_OPTIONS.CORNIS_BULK_GENERATE,
        acceptedMetadataFileTypes: 'text/plain,application/json',
        imageFileTypes: '.cr2',
      };
    default:
      return {
        inspectionType: CORNIS_BULK_UPLOAD_OPTIONS.CORNIS_BULK,
        validate: CORNIS_BULK_UPLOAD_OPTIONS.CORNIS_BULK_VALIDATE,
        validated: CORNIS_BULK_UPLOAD_OPTIONS.CORNIS_BULK_VALIDATED,
        generate: CORNIS_BULK_UPLOAD_OPTIONS.CORNIS_BULK_GENERATE,
        acceptedMetadataFileTypes: 'text/plain,application/json',
        imageFileTypes: '.cr2',
      };
  }
};
